import {
    filterExpiredSessions,
    filterMissingDynamicModules,
    filterOfflineErrors,
    filterResizeObserverErrors,
    initSentry,
    reactRouterV7BrowserTracingIntegration,
    tagSharedPackage,
} from '@tlx/sentry';
import { useEffect } from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router';

export function initSalarySentry() {
    initSentry({
        appName: 'salary',
        team: 'TSK',
        release: `salary@${__APP_VERSION__}`,
        integrations: [
            reactRouterV7BrowserTracingIntegration({
                useEffect,
                useLocation,
                useNavigationType,
                createRoutesFromChildren,
                matchRoutes,
            }),
        ],
        eventProcessors: [
            filterOfflineErrors,
            filterExpiredSessions,
            filterMissingDynamicModules,
            filterResizeObserverErrors,
            tagSharedPackage,
        ],
    });
}
